// @flow
import React from 'react';
import { CdnImage } from '@ta/common.cdn';
import classNames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import styles from './SavesCardAnimation.css';

type Props = {|
  imagePath: string,
  active: boolean,
  filled: boolean,
|};

const StackedHeart = (props: { active: boolean, filled: boolean }) => (
  <span className={classNames('ui_icon_stacked', styles.heart, { [styles.active]: props.active })}>
    <span className={styles.ui_icon_stacked_inner}>
      {props.filled && (
        <Icon name="heart-fill" className={classNames('stacked', styles.innerIcon)} />
      )}
      <Icon name="heart" className={classNames('stacked', styles.outerIcon)} />
    </span>
  </span>
);

const SavesCard = (props: Props) => {
  const { imagePath, active, filled } = props;

  return (
    <React.Fragment>
      <StackedHeart active={active} filled={filled} />
      <CdnImage src={imagePath} className={styles.image} />
    </React.Fragment>
  );
};

export default SavesCard;
